import NormalLayout from './NormalLayout';

export default {
  install(Vue) {
    Vue.component('normal-layout', NormalLayout)
  }
}
